import RaceMenu from "./MiscMenuItems/RaceMenu";
import ProviderMenu from "./MiscMenuItems/ProviderMenu";

interface MiscMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  setCentersCheck: (val: boolean) => void;
  centersCheck: boolean;
  clear: boolean;
  setClear: (val: boolean) => void;
  clearClickable: boolean;
  showCentersCheckbox?: boolean;
  setIsFiltersOpen?: () => void;
}

const MiscMenu: React.FC<MiscMenuProps> = ({
  setDisplayValue,
  displayValue,
  setCentersCheck,
  centersCheck,
  setClear,
  clear,
  clearClickable,
  showCentersCheckbox = true,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  const handleCentersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCentersCheck(event.target.checked);
  };
  return (
    <ul>
      {showCentersCheckbox && (
        <li>
          <label className="label cursor-pointer justify-start ml-5">
            <input
              type="checkbox"
              onChange={handleCentersChange}
              checked={centersCheck}
              className="checkbox checkbox-xs checkbox-accent checked::border-accent bg-white"
            />
            <span className="text-valmidnight text-base ml-2">
              HCM center (Overlay)
            </span>
          </label>
        </li>
      )}

      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={76}
            checked={!clear && displayValue === 76}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Poverty (US Census){" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={77}
            checked={!clear && displayValue === 77}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Uninsured (US Census)
          </span>
        </label>
      </li>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">
            Provider Type{" "}
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <ProviderMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}></ProviderMenu>
          </p>
        </div>
      </div>
      {/* <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{ position: "static" }}
        >
          <div className="ml-5 text-nowrap text-valmidnight">
            %Race/Ethnicity
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <RaceMenu setDisplayValue={setDisplayValue}></RaceMenu>
          </p>
        </div>
      </div> */}
    </ul>
  );
};

export default MiscMenu;
